import { render, staticRenderFns } from "./common-title.vue?vue&type=template&id=d90fe8f2&scoped=true"
import script from "./common-title.vue?vue&type=script&lang=js"
export * from "./common-title.vue?vue&type=script&lang=js"
import style0 from "./common-title.vue?vue&type=style&index=0&id=d90fe8f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90fe8f2",
  null
  
)

export default component.exports